<template>
	<div>
		<div>
			<label class="col-form-label">Когда планируете покупать?</label>
			<el-select
				class="col-md-12 select-primary"
				size="large"
				placeholder="Период"
				v-model="value.buy"
			>
				<el-option
					v-for="(el_opt, el_index) in options_buy"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
		<div>
			<label class="col-form-label">Когда хотите получить ключи?</label>
			<el-select
				class="col-md-12 select-primary"
				size="large"
				placeholder="Период"
				v-model="value.keys"
			>
				<el-option
					v-for="(el_opt, el_index) in options_keys"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReUrgency',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: Object,
			options_buy: Array,
			options_keys: Array,
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>

</style>
